/**
 * SettingsSection — one titled card in the Settings form: a heading, an
 * optional description, and a three-column grid body. `SettingsView` composes
 * seven of these (Time zone · Region · Sender · Sequence · Options ·
 * Limits · Pause); a field that needs the full row sets `md:col-span-3` on itself.
 */
import type { ReactNode } from 'react';

export interface SettingsSectionProps {
  title: string;
  description?: string;
  children: ReactNode;
}

export function SettingsSection({ title, description, children }: SettingsSectionProps) {
  const id = `settings-${title.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <section aria-labelledby={id} className="rounded-xl border border-border bg-card p-5">
      <h2 id={id} className="m-0 text-body-md-medium text-foreground">
        {title}
      </h2>
      {description ? <p className="mt-1 text-[12px] text-muted-foreground">{description}</p> : null}
      <div className="mt-4 grid gap-4 md:grid-cols-3">{children}</div>
    </section>
  );
}
